import { buildProps } from '@jdesign-vue/utils'
import { componentSizes } from '@jdesign-vue/constants'
import type { ExtractPropTypes } from 'vue'
import type Simple from './simple.vue'

export const paginationSimpleProps = buildProps({
  size: {
    type: String,
    values: componentSizes,
  },
} as const)

export type PaginationSimpleProps = ExtractPropTypes<
  typeof paginationSimpleProps
>

export type PaginationSimpleInstance = InstanceType<typeof Simple>
